module.exports = __webpack_public_path__ + "static/media/izlozba (12).fa64ce40.jpg";